import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Container from "react-bootstrap/Container";
import { Row, Card, Col } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import { GetAdminDashboard } from "../../apis/DashboardAPI";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTitle,
  ChartTooltip,
} from "@progress/kendo-react-charts";
import { GetNotifications } from "../../apis/NotificationAPI";
import dateFormat from "dateformat";

export default function AdminDashboard() {
  const [assignedCount, setAssignedCount] = useState(0);
  const [newCount, setNewCount] = useState(0);
  const [reopenedCount, setReopenedCount] = useState(0);
  const [progressCount, setProgressCount] = useState(0);
  const [prelimCount, setPrelimCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const [investigatorCount, setInvestigatorCount] = useState(0);
  const [reportCount, setReportCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data.slice(0, 4));
  }

  useEffect(() => {
    async function GetAdminData() {
      var result = await GetAdminDashboard();
      var data1 = result.data.item1;
      var data2 = result.data.item2;
      let new_count = data2.filter((f) => f.order_status_name === "New")[0]
        .total_orders;
      let assigned_count = data2.filter(
        (f) => f.order_status_name === "Assigned"
      )[0].total_orders;
      let progress_count = data2.filter(
        (f) => f.order_status_name === "In Progress"
      )[0].total_orders;
      let prelim_count = data2.filter(
        (f) => f.order_status_name === "Preliminary"
      )[0].total_orders;
      let completed_count = data2.filter(
        (f) => f.order_status_name === "Completed"
      )[0].total_orders;
      let reopened_count = data2.filter(
        (f) => f.order_status_name === "Reopened"
      )[0].total_orders;
      setAssignedCount(assigned_count);
      setNewCount(new_count);
      setReopenedCount(reopened_count);
      setProgressCount(progress_count);
      setPrelimCount(prelim_count);
      setCompletedCount(completed_count);
      setCustomerCount(data1.customer_count);
      setInvestigatorCount(data1.investigator_count);
      setReportCount(data1.report_count);
    }
    GetAdminData();
    GetUserNotifications();
  }, []);

  const series = [
    { category: "New", value: newCount },
    { category: "Assigned", value: assignedCount },
    { category: "In progress", value: progressCount },
    { category: "Preliminary", value: prelimCount },
    { category: "Completed", value: completedCount },
    { category: "Reopened", value: reopenedCount },
  ];

  window.addEventListener("notification", () => {
    GetUserNotifications();
  });

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <h1>Dashboard</h1>
                <Row>
                  <Col lg={4} md={12} className="mb-5">
                    <div cardinfo="data-Orders" className="cards card">
                      <div className="cards-head">
                        <div className="cards-title h5">Orders</div>
                      </div>
                      <div className="cards-body">
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <span className="text-blue">Assigned:</span>{" "}
                              {assignedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-blue">Unassigned:</span>{" "}
                              {newCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-blue">Reopened:</span>{" "}
                              {reopenedCount}
                            </div>
                          </div>
                        </div>
                      </div>
                      <Link to="/admin/Customers" className="cards-link">
                        View All Customers
                      </Link>
                    </div>
                  </Col>
                  <Col lg={4} md={12} className="mb-5">
                    <Card>
                      <Card.Body>
                        <div className="cards-head">
                          <Card.Title className="bold-heading">
                            System Stats
                          </Card.Title>
                        </div>
                        <div className="cards-body">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item">
                                <span>Customers:</span> {customerCount}
                              </div>
                              <div className="cards-list-item">
                                <span>Investigators:</span> {investigatorCount}
                              </div>
                              <div className="cards-list-item">
                                <span>Reports:</span> {reportCount}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={4} md={12} className="mb-5">
                    <Card>
                      <Card.Body>
                        <Chart>
                          <ChartLegend position="bottom" />
                          <ChartTitle
                            className="order-head-text"
                            text="Orders"
                          />
                          <ChartTooltip visible={true} />
                          <ChartSeries>
                            <ChartSeriesItem
                              type="pie"
                              data={series}
                              field="value"
                              categoryField="category"
                            >
                              <ChartSeriesItemTooltip format="{0}" />
                            </ChartSeriesItem>
                          </ChartSeries>
                        </Chart>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col lg={8}>
                    <Card className="notifications-card">
                      <div className="card-head">
                        <div className="card-title h5 bold-heading">
                          Notifications
                        </div>
                      </div>
                      <ul className="notifications-list max-no-list">
                        {notificationList.map((item) =>
                          item.order_status_name === "New" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                was submitted by{" "}
                                {item.requestor_name === ""
                                  ? "System"
                                  : item.requestor_name}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Completed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                was marked completed by{" "}
                                {item.investigator_name === "" || item.reopened != 0
                                  ? item.order_user
                                  : item.investigator_name}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Invoiced" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Invoice generated for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name ===
                            "Statements Generated" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Statement generated for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "In Progress" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} started working on
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Preliminary" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} submitted preliminary
                                report for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Assigned" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} assigned Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                to {item.investigator_name}.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Initial Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} has sent Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}'s
                                </Link>{" "}
                                initial report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Initial Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed initial report of
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim In Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} has sent Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}'s
                                </Link>{" "}
                                prelim report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed prelim report of
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Reopened Complete" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has completed reopened
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                      {notificationList.length > 0 ? (
                        <Card.Link href="/Admin/AdminNotifications">
                          View All
                        </Card.Link>
                      ) : (
                        ""
                      )}
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
